import { Component, OnInit, Input } from '@angular/core';
import { TypeWebhook } from 'src/api/models';

@Component({
  selector: 'app-webhook-type',
  templateUrl: './webhook-type.component.html',
  styleUrls: ['./webhook-type.component.css']
})
export class WebhookTypeComponent implements OnInit {

  @Input('id') public id: number;

  constructor() { }

  ngOnInit(): void {
  }

  GetWebhookType(t: TypeWebhook) {
    return TypeWebhook[t];
  } 
}
